const ru = {
  // Sidebar
  menu: 'МЕНЮ',
  dashboard: 'Главная',
  accounts: 'Аккаунты',
  proxies: 'Прокси',
  statistics: 'Статистика',
  campaigns: 'Кампании',
  comments: 'Комментарии',
  apiStatus: 'СТАТУС API',
  connected: 'Подключено',
  disconnected: 'Отключено',
  adAnalytics: 'Аналитика рекламы',

  // Dashboard
  dashboardTitle: 'Главная',
  dashboardSubtitle: 'Добро пожаловать! Вот что происходит с вашими кампаниями.',
  adAccounts: 'Рекламных аккаунтов',
  connectedAccounts: 'Подключённые аккаунты',
  proxiesCount: 'Прокси',
  proxyServers: 'Прокси-серверов',
  activeCampaigns: 'Активных кампаний',
  runningNow: 'Работают сейчас',
  totalSpend: 'Общий расход',
  lifetime: 'За всё время',
  getStarted: 'Начните работу с Meta Stats',
  getStartedDesc: 'Подключите первый рекламный аккаунт Facebook для отслеживания эффективности кампаний, расходов и метрик вовлечённости.',
  addAccount: 'Добавить аккаунт →',
  realtimeStats: 'Статистика в реальном времени',
  realtimeStatsDesc: 'Отслеживайте расходы, показы, клики и CTR по всем кампаниям в реальном времени.',
  proxyManagement: 'Управление прокси',
  proxyManagementDesc: 'Маршрутизируйте API-запросы через прокси-серверы для обхода ограничений.',
  commentModeration: 'Модерация комментариев',
  commentModerationDesc: 'Просматривайте и скрывайте комментарии к рекламе прямо из панели управления.',

  // Accounts
  accountsTitle: 'Аккаунты',
  accountsSubtitle: 'Подключайте и управляйте рекламными аккаунтами Facebook',
  addViaToken: 'Добавить через Access Token',
  systemUserToken: 'System User Token или Graph API Explorer',
  accessTokenPlaceholder: 'Access Token',
  namePlaceholder: 'Название (необязательно)',
  addAccountBtn: '+ Добавить аккаунт',
  accountsTable: 'Аккаунты',
  name: 'НАЗВАНИЕ',
  token: 'ТОКЕН',
  status: 'СТАТУС',
  noAccounts: 'Аккаунтов пока нет',
  noAccountsDesc: 'Добавьте первый рекламный аккаунт Facebook выше',

  // Proxies
  proxiesTitle: 'Прокси',
  proxiesSubtitle: 'Управляйте прокси-серверами для API-запросов',
  addProxies: 'Добавить прокси',
  onePerLine: 'по одному на строку: host:port или host:port:user:pass',
  protocol: 'Протокол',
  addProxiesBtn: '+ Добавить прокси',
  validateAll: 'Проверить все',
  proxyList: 'Список прокси',
  host: 'ХОСТ',
  port: 'ПОРТ',
  auth: 'АВТОРИЗАЦИЯ',
  noProxies: 'Прокси не добавлены',
  noProxiesDesc: 'Добавьте прокси-серверы с помощью формы выше',

  // Statistics
  statisticsTitle: 'Статистика',
  statisticsSubtitle: 'Показатели эффективности и тренды кампаний',
  account: 'Аккаунт',
  period: 'Период',
  last7days: 'Последние 7 дней',
  last30days: 'Последние 30 дней',
  last90days: 'Последние 90 дней',
  loadStats: 'Загрузить статистику',
  selectAccount: 'Выберите аккаунт для загрузки статистики',
  chooseAccountAndPeriod: 'Выберите аккаунт, период и нажмите «Загрузить статистику»',
  spend: 'Расход',
  impressions: 'Показы',
  clicks: 'Клики',
  ctr: 'CTR',
  dailySpend: 'Расход по дням',

  // Campaigns
  campaignsTitle: 'Кампании',
  campaignsSubtitle: 'Просмотр и управление рекламными кампаниями',
  selectAccountPlaceholder: 'Выберите аккаунт',
  loadCampaigns: 'Загрузить кампании',
  campaign: 'КАМПАНИЯ',
  objective: 'ЦЕЛЬ',
  budget: 'БЮДЖЕТ',
  noCampaigns: 'Выберите аккаунт',
  noCampaignsDesc: 'Выберите аккаунт и нажмите «Загрузить кампании»',

  // Comments
  commentsTitle: 'Комментарии',
  commentsSubtitle: 'Просмотр и модерация комментариев к рекламе',
  adId: 'ID объявления',
  loadComments: 'Загрузить комментарии',
  comment: 'КОММЕНТАРИЙ',
  author: 'АВТОР',
  date: 'ДАТА',
  noComments: 'Введите ID объявления для загрузки комментариев',
  noCommentsDesc: 'Выберите аккаунт и введите ID объявления выше',
  hide: 'Скрыть',
  show: 'Показать',
  visible: 'Видимый',
  hidden: 'Скрытый',
};

export default ru;
